import { fromJS } from 'immutable';
import { TAXONOMY_TERM_GET_LOADED } from '../../../actions/Entity/TaxonomyTerm';
var initialState = fromJS({});
export default function taxonomy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case TAXONOMY_TERM_GET_LOADED:
      {
        return state.set(action.term_id, fromJS(action.data));
      }
    default:
      return state;
  }
}